module.exports = __WEBPACK_EXTERNAL_MODULE_30__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","platformBrowser"],"commonjs":"@angular/platform-browser","commonjs2":"@angular/platform-browser","amd":"@angular/platform-browser"}
// module id = 30
// module chunks = 0